$( () => {

    if ($(".swiper-services").length > 0 && window.innerWidth > 768) {
		var swiperServices = new Swiper(".swiper-services", {
			slidesPerView: 'auto',
			spaceBetween: 18,
			navigation: {
				nextEl: ".service-next",
				prevEl: ".service-prev",
			},
			breakpoints: {
				768: {
					// slidesPerView: 'auto',
				},
				992: {
					// slidesPerView: 2,
				},
				1200: {
					// slidesPerView: 3,
				},
			},
		});
	}

    if ($(".swiper-services--small").length > 0 && window.innerWidth > 768) {
		var swiperServicesSmall = new Swiper(".swiper-services--small", {
			slidesPerView: 1,
			spaceBetween: 18,
			navigation: {
				nextEl: ".service-small-next",
				prevEl: ".service-small-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 18,
				},
				992: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
		});
	}

	if ($('.swiper-testimonial').length > 0)
	{
		var swiperTestimonial = new Swiper(".swiper-testimonial", {
			slidesPerView: 1,
			spaceBetween: 15,
			pagination: {
			  el: ".testimonial-pagination",
			  clickable: true,
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
			breakpoints: {
				768: {
					spaceBetween: 30,
				},
			},
		});

	}

	if ($('.swiper-articles').length > 0) {
		var swiperArticles = new Swiper(".swiper-articles", {
			slidesPerView: 1,
			pagination: {
				el: ".articles-pagination",
				clickable: true,
				//   dynamicBullets: true,
			},
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			// navigation: {
				//     nextEl: ".swiper-category-next",
				//     prevEl: ".swiper-category-prev",
				// },
			});
	}
	if ($('.swiper-articles-recent').length > 0) {
		var swiperArticlesRecent = new Swiper(".swiper-articles-recent", {
			slidesPerView: 1,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".swiper-racentA-next",
				prevEl: ".swiper-racentA-prev",
			},
		});
	}

	if ($('.swiper-gallery').length > 0)
	{
		//if ($('.js-player').length > 0) {
			const playersVideo = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p));
		//}
		const swiperGallery = new Swiper('.swiper-gallery', {
			// Optional parameters
			// loop: true,
			centeredSlides: true,
			slidesPerView: 1,
			autoHeight: true,
			initialSlide: 1,
			
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 3,
					autoHeight: false,
					initialSlide: 1,
				}
			},
		  
			// Navigation arrows
			navigation: {
			  nextEl: '.swiper-button-next',
			  prevEl: '.swiper-button-prev',
			},
			on: {
				slideChange: function () {
					playersVideo.forEach(element => {
						element.stop();
					});
				},
			},
		});
	}

	if ($('.swiper-gallery--small').length > 0)
	{
		const swiperGallerySmall = new Swiper('.swiper-gallery--small', {
			// Optional parameters
			// loop: true,
			slidesPerView: 1,
			
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},

			breakpoints: {
				768: {
					slidesPerView: 2,
				}
			},
		  
			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		  });
	}

	let swiperPromotions = '';
	if ($('.swiper-promotions').length > 0)
	{
		// const swiperProductsThumbs = new Swiper('.swiper-products--thumbs', {
		// 	watchSlidesProgress: true,
		// 	// freeMode: true,
		// 	slidesPerView: 1,
		// 	spaceBetween: 15,

		// 	breakpoints: {
		// 		768: {
		// 			slidesPerView: 3,
		// 			// centeredSlides: true,
		// 		},
		// 		1200: {
		// 			slidesPerView: 3,
		// 		}
		// 	},

		// });
		swiperPromotions = new Swiper('.swiper-promotions', {
			// Optional parameters
			slidesPerView: 1,
			centeredSlides: true,
			observeSlideVisibility: true, 
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},

			// thumbs: {
			// 	swiper: swiperProductsThumbs
			// },
			navigation: {
				nextEl: ".swiper-promotion-next",
				prevEl: ".swiper-promotion-prev",
			},

			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
				renderBullet: function (index, className) {
					// var title = $(this.$el).find('.swiper-slide').eq(index).attr("data-title");
					// var subTitle = $(this.$el).find('.swiper-slide').eq(index).attr("data-subtitle");
					var title = $('.swiper-promotions .swiper-slide-' + index).attr("data-title");
					var subTitle = $('.swiper-promotions .swiper-slide-' + index).attr("data-subtitle");
					return `<span class="${className} pagination-item" data-index="${index}">
						<div class="d-block bullet-box">
							${title}
							<span class="swiper-slide--subtitle">${subTitle}</span>
						</div>
					</span>`;
				},
			},

			breakpoints: {
				768: {
					slidesPerView: 3,
					initialSlide: 1,
					// initialSlide: 1,
				},
				992: {
					slidesPerView: 3,
					initialSlide: 1,
				}
			},
			on: {
				init: function () {
					//console.log('swiper initialized', this.activeIndex);
					$('#slider-promotions-configurator-url').attr('href', $('.swiper-promotions .swiper-slide-' + this.activeIndex).data('configurator-url'));
					$('#slider-promotions-configurator-url').attr('data-promotion-id', $('.swiper-promotions .swiper-slide-' + this.activeIndex).data('id'));
					$('#slider-promotions-url').attr('href', $('.swiper-promotions .swiper-slide-' + this.activeIndex).data('url'));

					$('.swiper-promotions').find('.promotion-link').css('visibility', 'hidden');
					$('.swiper-promotions .swiper-slide-' + this.activeIndex).find('.promotion-link').css('visibility', 'visible');
				},
			},
		});

		swiperPromotions.on('slideChange', function () {
			//console.log('slide changed', swiperPromotions.activeIndex);
			$('#slider-promotions-configurator-url').attr('href', $('.swiper-promotions .swiper-slide-' + swiperPromotions.activeIndex).data('configurator-url'));
			$('#slider-promotions-configurator-url').attr('data-promotion-id', $('.swiper-promotions .swiper-slide-' + swiperPromotions.activeIndex).data('id'));
			$('#slider-promotions-url').attr('href', $('.swiper-promotions .swiper-slide-' + swiperPromotions.activeIndex).data('url'));

			$('.swiper-promotions').find('.promotion-link').css('visibility', 'hidden');
			$('.swiper-promotions .swiper-slide-' + swiperPromotions.activeIndex).find('.promotion-link').css('visibility', 'visible');
		});
	}
	let promotionsSlides =  document.querySelectorAll('.swiper-promotions .swiper-slide');
	// Attach click event listener to each slide
	promotionsSlides.forEach(function(slide, index) {
		slide.addEventListener('click', function() {
			swiperPromotions.slideTo(index); // Make the clicked slide active
		});
	});

	let swiperProducts = '';
	if ($('.swiper-products').length > 0)
	{
		// const swiperProductsThumbs = new Swiper('.swiper-products--thumbs', {
		// 	watchSlidesProgress: true,
		// 	// freeMode: true,
		// 	slidesPerView: 1,
		// 	spaceBetween: 15,

		// 	breakpoints: {
		// 		768: {
		// 			slidesPerView: 3,
		// 			// centeredSlides: true,
		// 		},
		// 		1200: {
		// 			slidesPerView: 3,
		// 		}
		// 	},

		// });
		swiperProducts = new Swiper('.swiper-products', {
			// Optional parameters
			slidesPerView: 1,
			centeredSlides: true,
			scrollbar: {
				el: '.swiper-scrollbar',
				draggable: true,
			},

			// thumbs: {
			// 	swiper: swiperProductsThumbs
			// },
			navigation: {
				nextEl: ".swiper-product-next",
				prevEl: ".swiper-product-prev",
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
				renderBullet: function (index, className) {
					// var title = $(this.$el).find('.swiper-slide').eq(index).attr("data-title");
					// var subTitle = $(this.$el).find('.swiper-slide').eq(index).attr("data-subtitle");
					var title = $('.swiper-products .swiper-slide-' + index).attr("data-title");
					var subTitle = $('.swiper-products .swiper-slide-' + index).attr("data-subtitle");
					return `<span class="${className} pagination-item" data-index="${index}">
						<div class="d-block bullet-box">
							${title}
							<span class="swiper-slide--subtitle">${subTitle}</span>
						</div>
					</span>`;
				},
			},

			breakpoints: {
				768: {
					slidesPerView: 3,
					initialSlide: 1,
					// initialSlide: 1,
				},
				992: {
					slidesPerView: 3,
					initialSlide: 1,
				}
			},
			on: {
				init: function () {
					var modulId = $('.swiper-products .swiper-slide-' + this.activeIndex).data('module-id');

					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_url != '') {
						$('#button-1-' + modulId).attr('href', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_url);
					}
					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_target == '1') {
						$('#button-1-' + modulId).attr('target', '_blank');
					}
					$('#button-1-' + modulId).attr('data-dealer-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').dealer_id);
					$('#button-1-' + modulId).attr('data-model-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').model_id);
					$('#button-1-' + modulId).attr('data-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').model_id);
					$('#button-1-' + modulId).attr('data-type', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').type);
					$('#button-1-' + modulId).text($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_label);
					var btn1Classes = 'btn btn-outline-dark rounded-0 d-block px-2 ';
					$("#button-1-" + modulId).removeClass();
					$("#button-1-" + modulId).addClass(btn1Classes + $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_class);
					$("#button-1-" + modulId).parent().hide();
					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_1_label != '') {
						$("#button-1-" + modulId).parent().show();
					}
					//console.log($('.swiper-products .swiper-slide-' + this.activeIndex).data('data'));

					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_url != '') {
						$('#button-2-' + modulId).attr('href', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_url);
					}
					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_target == '1') {
						$('#button-2-' + modulId).attr('target', '_blank');
					}
					$('#button-2-' + modulId).attr('data-dealer-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').dealer_id);
					$('#button-2-' + modulId).attr('data-model-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').model_id);
					$('#button-2-' + modulId).attr('data-id', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').model_id);
					$('#button-2-' + modulId).attr('data-type', $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').type);
					$('#button-2-' + modulId).html('<i class="far fa-arrow-right me-2"></i>'+$('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_label);
					var btn2Classes = 'btn btn-dark rounded-0 d-block px-2 ';
					$("#button-2-" + modulId).removeClass();
					$("#button-2-" + modulId).addClass(btn2Classes + $('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_class);
					$("#button-2-" + modulId).parent().hide();
					if ($('.swiper-products .swiper-slide-' + this.activeIndex).data('data').button_2_label != '') {
						$("#button-2-" + modulId).parent().show();
					}
				},
			},
		});

		swiperProducts.on('slideChange', function () {
			//console.log('slide changed', swiperProducts.activeIndex);
			var modulId = $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('module-id');

			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_url != '') {
				$('#button-1-' + modulId).attr('href', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_url);
			}
			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_target == '1') {
				$('#button-1-' + modulId).attr('target', '_blank');
			}
			$('#button-1-' + modulId).attr('data-dealer-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').dealer_id);
			$('#button-1-' + modulId).attr('data-model-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').model_id);
			$('#button-1-' + modulId).attr('data-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').model_id);
			$('#button-1-' + modulId).attr('data-type', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').type);
			$('#button-1-' + modulId).text($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_label);
			var btn1Classes = 'btn btn-outline-dark rounded-0 d-block px-2 ';
			$("#button-1-" + modulId).removeClass();
			$("#button-1-" + modulId).addClass(btn1Classes + $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_class);
			$("#button-1-" + modulId).parent().hide();
			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_1_label != '') {
				$("#button-1-" + modulId).parent().show();
			}
			//console.log($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data'));

			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_url != '') {
				$('#button-2-' + modulId).attr('href', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_url);
			}
			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_target == '1') {
				$('#button-2-' + modulId).attr('target', '_blank');
			}
			$('#button-2-' + modulId).attr('data-dealer-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').dealer_id);
			$('#button-2-' + modulId).attr('data-model-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').model_id);
			$('#button-2-' + modulId).attr('data-id', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').model_id);
			$('#button-2-' + modulId).attr('data-type', $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').type);
			$('#button-2-' + modulId).html('<i class="far fa-arrow-right me-2"></i>'+$('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_label);
			var btn2Classes = 'btn btn-dark rounded-0 d-block px-2 ';
			$("#button-2-" + modulId).removeClass();
			$("#button-2-" + modulId).addClass(btn2Classes + $('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_class);
			$("#button-2-" + modulId).parent().hide();
			if ($('.swiper-products .swiper-slide-' + swiperProducts.activeIndex).data('data').button_2_label != '') {
				$("#button-2-" + modulId).parent().show();
			}
		});
	}
	let productSlides =  document.querySelectorAll('.swiper-products .swiper-slide');
	// Attach click event listener to each slide
	productSlides.forEach(function(slide, index) {
			slide.addEventListener('click', function() {
				swiperProducts.slideTo(index); // Make the clicked slide active
		});
	});
	let swiperProductsHeroThumbs = ''
	if ($('.swiper-products--hero-thumbs').length > 0)
	{
		swiperProductsHeroThumbs = new Swiper('.swiper-products--hero-thumbs', {
			watchSlidesProgress: true,
			// freeMode: true,
			slidesPerView: 'auto',
			// spaceBetween: 6,
			// centeredSlides: true,
			// centerInsufficientSlides: true,
			// centeredSlidesBounds: true,
	
			breakpoints: {
				768: {
					// slidesPerView: 4,
				},
				1200: {
					// slidesPerView: 9,
					centeredSlides: true,
					centerInsufficientSlides: true,
					centeredSlidesBounds: true,
				}
			},
	
		});
	}
	
	if ($('.swiper-products--hero').length > 0) {
		let swiperProductsHero = new Swiper(".swiper-products--hero", {
			slidesPerView: 1,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			// pagination: {
			// 	el: ".swiper-pagination",
			// 	clickable: true,
			// 	renderBullet: function (index, className) {
			// 		console.log(className);
			// 		var title = $(this.$el).find('.swiper-slide').eq(index).attr("data-title");
			// 		return `<span class=${className}>` + title + '</span>';
			// 	},
			// },

			thumbs: {
				swiper: swiperProductsHeroThumbs
			},
		});
	}

	
	
	if ($('.swiper-hero').length > 0) {
		const progressCircle = document.querySelector(".autoplay-progress svg");
    	// const progressContent = document.querySelector(".autoplay-progress span");
		const swiperHero = new Swiper(".swiper-hero", {
			slidesPerView: 1,
			speed: 1500,
			// autoplay: false,
			// loop: true,
			autoplay: {
				//delay: 6000,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			limitProgress: 1,
			on: {
				afterInit: function () {
					// Start the custom slide interval when Swiper is initialized
					//this.customAutoplay();
					if ($(window).width() < 768) {
						var imgHeight = $('.swiper-hero .swiper-slide-0 .swiper-asset').height();
						if (imgHeight > 0) {
							$('.swiper-hero .swiper-pagination').css('top', imgHeight+20);
							$('.swiper-hero .swiper-btn').css('top', imgHeight+12);
							$('.swiper-hero .autoplay-progress').css('top', imgHeight+8);
						}
					}
				},
				autoplayTimeLeft(swiperHero, time, progress) {
					progressCircle.style.setProperty("--progress", progress);
					var offset = 125.6 - progress * 125.6; // 283 is the circumference of the circle (2 * π * radius)
					progressCircle.style.strokeDashoffset = offset;
				//   progressContent.textContent = `${Math.ceil(time / 1000)}s`;
				}
			}
		});

		$( ".swiper-btn" ).on( "click", function() {
			var video = $('.swiper-hero .swiper-slide-active').find('video');

			if ( $(this).hasClass('active') ) 
			{
				swiperHero.autoplay.pause();
				if (video.length > 0) {
					video[0].pause();
				}
			} else
			{
				swiperHero.autoplay.resume();
				if (video.length > 0) {
					video[0].play();
				}
			}
			$( this ).toggleClass( "active" );
		} );
	}
	  
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js